<template>
  <div class="login-mainter">
    <div class="form-wrap">
      <el-form ref="form"
               :model="form"
               label-width="80px">
        <div class="login-top">
          <p>售电管理系统</p>
          <span>Business Management System</span>
        </div>
        <el-form-item prop="username"
          :rules="[
            { required: true, message: '账号不能为空'},
          ]">
          <el-input prefix-icon="el-icon-user-solid"
            v-model="form.username"
            placeholder="请输入用户账号"></el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item prop="password"
          :rules="[
            { required: true, message: '密码不能为空'},
            { min: 7, message: '密码长度至少为7位', trigger: 'blur' }
          ]">
          <el-input :type="show?'text':'password'"
            prefix-icon="el-icon-unlock"
            v-model="form.password"
            placeholder="请输入登录密码"
            minlength="7"
           >
              <i slot="suffix" class="el-icon-view" @click="show=!show"></i>
              </el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-login"
                     type="primary"
                     @click="handleLogin('form')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Encrypt } from '../../util/secret.js'
import { login , save_login_log} from '../../API'
export default {
  name: "AppLogin",
  data () {
    return {
      form: {
        username: "",
        password: ""
      },
      show:false
    };
  },
  methods: {
    handleLogin (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
                 let data = {
                     username: this.form.username,
                     password: Encrypt(this.form.password)
                   }
                 login(data).then(res => {
                     if (res.code === 0) {
                       localStorage.setItem('username', this.form.username)
                       localStorage.setItem('accessKey', res.data)
                       let that = this;
                       that.saveLoginLog()
                       setTimeout(
                         function () {
                           that.$router.push({
                             path: '/sy/xtsy'
                           })
                         }, 1000
                       )

                     }
                   })
                     .catch(e => {
                     this.$message.error("网络异常");
                   })
                 // this.$http({
                 //   method: "POST",
                 //   url: `https://c.cesc-energy.com/service/user/login`,
                 //   data: {
                 //     username: this.form.username,
                 //     password: Encrypt(this.form.password)
                 //   }
                 // })
                 //   .then(res => {
                 //     if (res.data.code === 0) {
                 //       localStorage.setItem('username', this.form.username)
                 //       localStorage.setItem('accessKey', res.data.data)
                 //       let that = this
                 //       setTimeout(
                 //         function () {
                 //           that.$router.push({
                 //             path: '/sy/xtsy'
                 //           })
                 //         }, 1000
                 //       )

                 //     } else if (res.data.status === "201") {
                 //       this.$message.error(res.data.success);
                 //     } else {
                 //       this.$message.error(res.data.msg);
                 //     }
                 //   })
                 //   .catch(e => {
                 //     console.log(e)
                 //     this.$message.error("网络异常");
                 //   })
               }

      });

    },
    // 保存用户登录信息
    saveLoginLog(){
      save_login_log().then(res =>{
        console.log("res",res)
      })
    },
  }
};
</script>

<style lang='less' scoped>
.login-mainter {
  height: 100%;
  background-color: #2a564712;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-top {
  text-align: center;
  margin: 20px auto;
}
.login-top p {
  font-size: 24px;
}
.form-wrap {
  width: 400px;
  background-color: #fff;
  border-radius: 10px;
  .btn-login {
    width: 100%;
  }
}
.el-form-item {
  margin-right: 80px;
}
</style>
